import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Content } from '../../models/content';
import { disclaimerRequest } from '../../models/Flow';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { FeedbackService } from './feedback.service';
import { FlowInformationService } from '../flow-information/flow-information.service';
import html2canvas from 'html2canvas';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../../loader/loader.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  public appBase = TCCPConstantValues[environment.applicationName];
  public alerts: any[] = [];
  public thumbnilPath: string = '';
  public windowWidth: number;
  public screenshot: any;
  public appName = environment.applicationName;

  constructor(
    private flowInformationService: FlowInformationService, private dialog: MatDialog, private loaderService: LoaderService) { }

  ngOnInit() {
    this.windowWidth = window.innerWidth;
  }

  asyncAction() {
    const promise = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        html2canvas(document.querySelector('#' + this.appName + '-app')).then(canvas => {
          this.screenshot = canvas.toDataURL();
        });
        resolve();
      }, 1500);
    });
    return promise;
  }

  openFeedbackDialog(): void {
    this.loaderService.show();
    this.asyncAction().then(() => {
      const dialogRef = this.dialog.open(FeedbackDialogComponent, {
        id: this.appName + '-feedback-dialog',
        width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '35vw' : '45vw' : '80vw',
        data: this.screenshot,
        height: this.windowWidth && this.windowWidth > 1200 ? 'auto' : '85%'
      });
      this.loaderService.hide();
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.event && result.event === 'save') {
        }
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.windowWidth = window.innerWidth;
  }

}

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackDialogComponent implements OnInit {
  public appBase = TCCPConstantValues[environment.applicationName];
  public alerts: any[] = [];
  public imageSrc = '';
  public filename = '';
  public icon = '';
  public type: string;
  public thumbnilPath = '';
  public theme = '';
  public feedbackForm: FormGroup;

  public feedbackDetails: Content = < Content > ({
    contentType: 'email', featureType: null, feedback: {
      model: null, year: null, firstName: null, lastName: null,
      feedback: null, email: null, phoneNumber: null, feature: null, screenshotURL: null, includeScreenshot: false
    }
  });

  constructor(
    private fb: FormBuilder, public storageService: TCCPLocalStorageService, public dialogRef: MatDialogRef<FeedbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private feedbackService: FeedbackService,
    private flowInformationService: FlowInformationService, private snackBar: MatSnackBar,
    private loaderService: LoaderService, private authService: MsalService) { }

  ngOnInit() {
    this.theme = environment.applicationName;
    const modelName = this.storageService.getVehicleModel();
    const vehicleModelName = modelName && modelName.name === '' ? this.storageService.getVehicleModelName() : modelName.name;
    this.feedbackForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phoneNumber: new FormControl(),
      feature: new FormControl({ value: this.storageService.getFeature().name, disabled: true }),
      model: new FormControl({ value: vehicleModelName, disabled: true }, ),
      year: new FormControl({ value: this.storageService.getVehicleYear().name, disabled: true }, ),
      feedback: new FormControl('', Validators.required),
      feedbackType: new FormControl('', Validators.required)
    });

    const feedback: Content = <Content> ({
      contentType: 'email', featureType: null, feedback: {
        model: null, year: null, firstName: null, lastName: null,
        feedback: null, email: null, feature: null, screenshotURL: null, includeScreenshot: false, phoneNumber: null
      }
    }
    );
    if (this.storageService.featureType === 'internal') {
      this.feedbackForm.controls.firstName.setValue(this.authService.instance.getActiveAccount().name.split(' ',2)[0]);
      this.feedbackForm.controls.lastName.setValue(this.authService.instance.getActiveAccount().name.split(' ',2)[1]);
      this.feedbackForm.controls.email.setValue(this.authService.instance.getActiveAccount().username);
    }
    this.feedbackDetails = feedback;
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.feedbackForm.controls[controlName].hasError(errorName);
  }

  includeScreenshot(event) {
    if (this.feedbackDetails.feedback.includeScreenshot) {
      this.feedbackDetails.feedback.screenshotURL = this.flowInformationService.screenshotInfo;
    }
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: "image/png" });
  }

  b64toBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
  }

  closeAlerts() {
    this.alerts = [];
  }

  onSave(feedbackForm) {
    this.feedbackForm.markAllAsTouched();
    this.loaderService.show();
    if (this.feedbackForm.valid) {
      this.feedbackDetails.division = environment.applicationName;
      this.feedbackDetails.feedback = {
        email: feedbackForm.email,
        phoneNumber: feedbackForm.phoneNumber,
        model: this.storageService.getVehicleModel().name,
        feedback: feedbackForm.feedback,
        year: this.storageService.getVehicleYear().name,
        firstName: feedbackForm.firstName,
        lastName: feedbackForm.lastName,
        feature: this.storageService.getFeature().name,
        includeScreenshot: this.feedbackDetails.feedback.includeScreenshot,
        screenshotURL: this.feedbackDetails.feedback.screenshotURL,
        fileName: '',
        contentName: '',
        bucketName: '',
        feedbackType: feedbackForm.feedbackType
      };
      if (this.feedbackDetails.feedback.includeScreenshot) {
        const fileRequestBody = new disclaimerRequest();
        const name: string = 'Feedback_' + new Date().toISOString() + '.png';
        fileRequestBody.source = environment.applicationName;
        fileRequestBody.contentType = 'image/png';
        fileRequestBody.fileName = name;
        fileRequestBody.fileDisplayName = name;
        fileRequestBody.contentBase64 = null;
        this.feedbackService.uploadImage(fileRequestBody).subscribe((response: any) => {
          if (response) {
            const blob = this.b64toBlob(this.feedbackDetails.feedback.screenshotURL);
            const file = this.dataURLtoFile(this.feedbackDetails.feedback.screenshotURL, name);
            const responseJSON = JSON.parse(response);
            this.feedbackService.uploadtoS3(file, responseJSON.url, fileRequestBody.contentType)
              .subscribe((imageResponse: any) => {
                this.feedbackDetails.feedback.fileName = name;
                this.feedbackService.sendFeedbackMail(this.feedbackDetails).subscribe(data => {
                  if (data) {
                    this.dialogRef.close();
                    this.loaderService.hide();
                    this.snackBar.open(TCCPConstantValues.feedback.messages.FEEDBACK_SUCCESS_MESSAGE, '', {
                      duration: 2000,
                      panelClass: ['green-snackbar']
                    });
                  }
                }, error => {
                  this.dialogRef.close();
                  this.loaderService.hide();
                });
              });
          }
        });
      } else {
        this.feedbackService.sendFeedbackMail(this.feedbackDetails).subscribe(data => {
          if (data) {
            this.dialogRef.close();
            this.loaderService.hide();
            this.snackBar.open(TCCPConstantValues.feedback.messages.FEEDBACK_SUCCESS_MESSAGE, '', {
              duration: 2000,
              panelClass: ['green-snackbar']
            });
          }
        }, error => {
          this.loaderService.hide();
          console.log('Mail Not sent');
        });
      }
    } else {
      this.loaderService.hide();
    }
  }


  onCancel() {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

}
